import React from 'react'
import { FormattedMessage } from 'react-intl'

import Button from '../../components/Button'
import { Routes } from '../../const/routes'
import { Content, StyledTitle, Text, Wrapper } from './styled'

const ErrorPage = () => (
  <Wrapper>
    <Content>
      <StyledTitle text="404 Ooopppsss" />
      <Text>
        <FormattedMessage id="errorPage.root.text" />
      </Text>
      <Button theme="pink" bType="link" to={Routes.INDEX}>
        <FormattedMessage id="errorPage.root.button" />
      </Button>
    </Content>
  </Wrapper>
)

export default ErrorPage
